import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CustomCursor } from './CustomCursor';

export const Layout = ({ children }) => {
  return (
    <div className="relative">
      <CustomCursor />
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};